import { render, staticRenderFns } from "./HistoryIntroduction.vue?vue&type=template&id=7b283d3b&scoped=true"
import script from "./HistoryIntroduction.vue?vue&type=script&lang=js"
export * from "./HistoryIntroduction.vue?vue&type=script&lang=js"
import style0 from "./HistoryIntroduction.vue?vue&type=style&index=0&id=7b283d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b283d3b",
  null
  
)

export default component.exports